import AutocompleteRegions, { getLocationLabel } from './AutocompleteRegions';

export default AutocompleteRegions;
export { getLocationLabel };
